import React from 'react';
import { Field, FieldAttributes } from 'formik';
import styles from '../../Form.module.scss';

type PropsType = {
  name: string;
  validate?: (value: string) => string;
};

const FormSelect = (props: PropsType) => {
  return (
    <Field name={props.name} validate={props.validate}>
      {(fieldProps: FieldAttributes<any>) => (
        <div className={styles.errorField}>
          {fieldProps.meta.error && <div>{fieldProps.meta.error}</div>}
        </div>
      )}
    </Field>
  );
};

export default FormSelect;
